import cx from 'classnames';
import SVG from 'react-inlinesvg';
import check from 'assets/icons/check.svg';
import Checkbox from 'lib/Checkbox';
import { radioStyle } from 'lib/Radio/Radio';
import { BaseSelectOptionProps } from '../BaseSelect.types';

const BaseSelectOption: React.FC<BaseSelectOptionProps> = ({
  isSelected,
  innerRef,
  isMultiple,
  innerProps: { id, onClick },
  icon = check,
  dataPendoId,
  children,
  data,
  size = 'medium',
  optionControl = 'check',
  checkboxPosition = 'left',
}: BaseSelectOptionProps) => {
  const isExtraSmall = size === 'extra_small';
  const isSingleSelect = !isMultiple;
  const isRadio = isSingleSelect && optionControl === 'radio';

  return (
    <div
      onClick={onClick}
      role="presentation"
      className={cx('flex rounded-sm hover:bg-neutral-100 cursor-pointer mx-1 my-0.5', {
        'p-2': !isExtraSmall,
        'p-1': isExtraSmall,
        'text-primary': isSingleSelect,
        'bg-neutral-950-opacity-5 text-primary': isSingleSelect && isSelected,
        'hover:bg-primary-600-opacity-5 hover:text-primary': isSingleSelect && !isSelected,
        'sub-header-base': isSingleSelect && isSelected && !isExtraSmall,
        'body-sm': isSingleSelect && isExtraSmall,
        'font-medium': isSingleSelect && isExtraSmall && isSelected,
      })}
      data-pendo-id={dataPendoId}
    >
      <div className="flex flex-1 w-full items-center space-between pl-1 py-1" ref={innerRef} id={id}>
        <div
          className={cx('flex items-center', {
            'justify-between w-full': checkboxPosition === 'right',
          })}
        >
          {isMultiple && checkboxPosition === 'left' && (
            <div
              className={cx({
                'w-4 h-4': !isExtraSmall,
                'w-2 h-2': isExtraSmall,
              })}
            >
              <Checkbox isSelected={isSelected} dataTestId="base-select-checkbox" />
            </div>
          )}
          {isRadio && (
            <div
              data-test-id={data?.code ? `base-select-radio-${data.code}` : 'base-select-radio'}
              className={cx(radioStyle.base, radioStyle.size, {
                [radioStyle.selected]: isSelected,
                [radioStyle.unselected]: !isSelected,
              })}
            />
          )}
          {!isMultiple && !isRadio && !!icon && !isExtraSmall && (
            <div className="w-4 h-4">
              <SVG
                src={icon}
                className={cx('text-primary-600 block', {
                  visible: isSelected,
                  hidden: !isSelected,
                })}
              />
            </div>
          )}
          <div
            className={cx({
              'pl-2': !isExtraSmall && checkboxPosition === 'left',
            })}
          >
            {children}
          </div>
          {isMultiple && checkboxPosition === 'right' && (
            <div
              className={cx({
                'w-4 h-4': !isExtraSmall,
                'w-2 h-2': isExtraSmall,
              })}
            >
              <Checkbox isSelected={isSelected} dataTestId="base-select-checkbox" />
            </div>
          )}
        </div>
        {data?.subtext ? <div className="flex flex-1 justify-end text-sm text-neutral-800">{data.subtext}</div> : null}
      </div>
    </div>
  );
};

export default BaseSelectOption;
